import React, { useMemo, useState } from 'react';
import { VisitorForm } from '../common/VisitorForm';
import { DeclarationType } from '../../model/Model';
import { HealthDeclaration } from '../declaration/HealthDeclaration';
import { ActionButton } from '../common/ActionButton';
import { CheckboxInline } from '../common/CheckboxInline';
import { CheckinForm } from '../../service/checkin-flow';
import { useSiteState } from '../../state/state';

type  DetailStepProps = {
    buttonText: string,
    buttonLoadingText: string,
    buttonLoading: boolean,
    onStepComplete: (form: CheckinForm) => void
}

export const DetailStep = ({ buttonText, buttonLoadingText, onStepComplete, buttonLoading }: DetailStepProps) => {
    const { settings } = useSiteState();
    const [declarationMade, setDeclarationMade] = useState(false);

    const buttonDisabled = useMemo(() => {
        return !(declarationMade || !(settings?.declarationAnswer && settings?.declaration === DeclarationType.INLINE));
    }, [declarationMade, settings]);

    return (
        <>
            <VisitorForm onSubmit={onStepComplete} readonly={false}>
                {settings?.declaration === DeclarationType.INLINE ? (
                    <HealthDeclaration onSelectionMade={() => setDeclarationMade(true)} />
                ) : null}
                <ActionButton text={buttonLoading ? buttonLoadingText : buttonText} disabled={buttonDisabled || buttonLoading} submit />
                <CheckboxInline name='rememberMe' label='Remember contact details for next time' />
            </VisitorForm>
        </>
    );
};
